import { render, staticRenderFns } from "./hqStuPosition.vue?vue&type=template&id=9a82b82e&scoped=true"
import script from "./hqStuPosition.vue?vue&type=script&lang=js"
export * from "./hqStuPosition.vue?vue&type=script&lang=js"
import style0 from "./hqStuPosition.vue?vue&type=style&index=0&id=9a82b82e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a82b82e",
  null
  
)

export default component.exports